import * as leagues from './leagues';
import * as team from './team';

export default {
	leagues,
	team,
};